import { INVALID_STRING_DISALLOWED_CHARACTERS } from "@/constants/invalids";
import { PATTERN } from "@/constants/pattern";
import { getDisallowedCharacters, replaceStr } from "@/utils/string";
import { validator } from "@/utils/validator";

export const createOrganizationUserSchema = validator.object().shape({
  fullName: validator
    .string()
    .emptyToNull()
    .max(26)
    .test("is-valid-name", INVALID_STRING_DISALLOWED_CHARACTERS, function (value) {
      if (!value) return true;
      const disallowedCharacters = getDisallowedCharacters(value, PATTERN.NAME_CHARACTER);
      if (disallowedCharacters.length === 0) return true;
      const { path, createError } = this;
      return createError({
        path,
        message: () => replaceStr(INVALID_STRING_DISALLOWED_CHARACTERS, { characters: disallowedCharacters.join("、") }),
      });
    })
    .label("ユーザー名")
    .required(),
  email: validator.string().emptyToNull().email().max(60).label("メールアドレス").required(),
  role: validator.string().isSelection().emptyToNull().label("権限").required(),
  productContractIds: validator.array().of(validator.number().defined()).label("プロダクトアクセス権限").default([]),
});
